import {
	ADD_BOOK_PUBLISHER,
	UPDATE_BOOK_PUBLISHER,
	DELETE_BOOK_PUBLISHER,
	BOOK_PUBLISHERS,
	ADD_BOOK_PUBLISHER_ERROR,
	BOOK_PUBLISHER_DETAILS,
} from "../types/BookPublisherType";
import { message } from "antd";

const initialState = {
	list: null,
	total: 0,
	publisher: null,
};

const bookPublisherReducer = (state = initialState, action) => {
	switch (action.type) {
		case BOOK_PUBLISHERS: {
			const payload = action.payload;
			if (payload && typeof payload === "object" && "data" in payload && "total" in payload) {
				return { ...state, list: payload.data, total: payload.total };
			}
			return { ...state, list: payload };
		}
		case ADD_BOOK_PUBLISHER:
			if (!Array.isArray(state.list)) {
				state.list = [];
			}
			const list = [...state.list];
			list.push(action.payload);
			return { ...state, list };

		case BOOK_PUBLISHER_DETAILS:
			return { ...state, publisher: action.payload.data };

		case DELETE_BOOK_PUBLISHER:
			const filterpublisher = state.list.filter(
				(publisher) => publisher.id !== parseInt(action.payload) && publisher
			);

			return { ...state, list: filterpublisher };

		// return {
		//   list: [
		//     ...state.list.filter((sup) => sup.id !== parseInt(action.payload)),
		//   ],
		// };

		case ADD_BOOK_PUBLISHER_ERROR:
			message.error(action.payload);
			return state;
		default:
			return state;
	}
};

export default bookPublisherReducer;
